import { TBaseItem } from "@centricsoftware/design-system";
import { C8Node } from "c8-platform";
import { ISingleSelectOptionStore, NodeToOptionFunction } from "csi/components/types";
import { ILocaleProvider } from "designSystem/locale";
import { queryDataStoreNodes } from "src/c8-platform/service/dataStoreService";
import { IDataStoreParams } from "src/c8-platform/type/dataStore";

function defaultTransform(node: C8Node, loc: ILocaleProvider): TBaseItem {
	const id = node.$URL;
	const name = node.$Name;

	return {
		id,
		name,
	};
}

class DataStoreNodesStore implements ISingleSelectOptionStore {
	/** parameters to use to query data store */
	params: IDataStoreParams;

	/** function that will transform the data store result to an option to override the default */
	resultTransform?: NodeToOptionFunction;

	/** query data store and produce options */
	query = async (loc: ILocaleProvider): Promise<TBaseItem[]> => {
		const { params, resultTransform = defaultTransform } = this;
		const response = await queryDataStoreNodes(params);
		return response.NODES.ResultNode.map((node) => resultTransform(node, loc));
	};

	constructor(params: IDataStoreParams, resultTransform?: NodeToOptionFunction) {
		this.params = params;
		this.resultTransform = resultTransform;
	}
}

export default DataStoreNodesStore;